<template>
  <div class="bc-notice" :class="{ 'bc-notice--in': visible }">
    <div class="bc-notice__label">{{ $T('官网公告栏标题') }}</div>
    <button
      v-for="(item, idx) in items"
      :key="item"
      type="button"
      class="bc-notice__item"
      @click="onSelect"
    >
      <span class="bc-notice__idx">{{ idx + 1 }}.</span>
      <span class="bc-notice__text">{{ $T(item) }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BcHeroNotice',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [
        '2026年全国蹦床锦标赛暨南京世锦赛测试赛成功举办',
        '南京世锦赛和世青赛、年龄组比赛确认报名工作结束，参赛队伍数量和人数情况。',
      ],
    };
  },
  methods: {
    onSelect() {
      this.$message.info('Coming soon !');
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-notice {
  position: absolute;
  z-index: 35;
  left: 5%;
  top: 17%;
  width: 38%;
  max-width: 460px;
  padding: 12px 14px 8px;
  border-radius: 14px;
  background: rgba(12, 22, 48, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(10px);
  opacity: 0;
  transform: translateY(12px);
  transition: opacity 0.8s ease 0.25s, transform 0.8s ease 0.25s;
  pointer-events: auto;
}
.bc-notice--in {
  opacity: 1;
  transform: translateY(0);
}
.bc-notice__label {
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #ffd28a;
}
.bc-notice__item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  margin: 0;
  padding: 7px 4px;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  background: transparent;
  color: #fff;
  text-align: left;
  font-size: 13px;
  line-height: 1.45;
  cursor: pointer;
}
.bc-notice__item:hover {
  color: #ffe3b0;
}
.bc-notice__idx {
  flex: 0 0 auto;
  font-weight: 700;
}
.bc-notice__text {
  flex: 1;
}

@media (max-width: 768px) {
  .bc-notice {
    left: 12px;
    right: 12px;
    top: 108px;
    width: auto;
    padding: 10px 10px 6px;
  }
  .bc-notice__item {
    font-size: 12px;
    padding: 6px 2px;
  }
}
</style>



// WEBPACK FOOTER //
// BcHeroNotice.vue?f1bb2d50